import { ScrollArea } from '@/components/shadcn/scroll-area'
import { Sheet, SheetContent, SheetDescription, SheetTitle, SheetHeader, SheetTrigger } from '@/components/shadcn/sheet'
import { cn } from '@/lib/utils'
import clsx from 'clsx'
import React from 'react'

export const ComposedSheet = React.forwardRef<
  React.ElementRef<typeof ScrollArea>,
  {
    trigger: React.ReactNode
    triggerIncludesSheetTrigger?: boolean
    title?: React.ReactNode
    description?: React.ReactNode
    children: React.ReactNode
    wide?: boolean
    extraWide?: boolean
    isOpen?: boolean
    onOpenChange?: (open: boolean) => void
    onCancel?: () => void
  }
>(
  (
    {
      trigger,
      triggerIncludesSheetTrigger = false,
      title,
      description,
      children,
      wide = true,
      extraWide = false,
      isOpen: externalIsOpen,
      onOpenChange: externalOnOpenChange,
    },
    ref
  ) => {
    const [internalIsOpen, setInternalIsOpen] = React.useState(false)

    // Determine if we're using controlled or uncontrolled mode
    const isControlled = externalIsOpen !== undefined && externalOnOpenChange !== undefined
    const isOpen = isControlled ? externalIsOpen : internalIsOpen
    const onOpenChange = isControlled ? externalOnOpenChange : setInternalIsOpen

    return (
      <Sheet open={isOpen} onOpenChange={onOpenChange}>
        {triggerIncludesSheetTrigger ? trigger : <SheetTrigger asChild>{trigger}</SheetTrigger>}
        <SheetContent className={cn('!pointer-events-auto pr-0', { 'lg:max-w-3xl': wide, 'xl:max-w-5xl': extraWide })}>
          {title && (
            <SheetHeader className="sticky inset-0 border-b pb-5">
              <SheetTitle>{title}</SheetTitle>
              {description && <SheetDescription>{description}</SheetDescription>}
            </SheetHeader>
          )}
          <ScrollArea ref={ref} className={clsx(title ? 'h-[calc(100%-77px)]' : 'h-full')}>
            {/* <div className="pl-1 pr-6">{children}</div> */}
            <div className={cn('pl-1 pr-6', { 'lg:max-w-[46.75rem]': wide, 'xl:max-w-[62.75rem]': extraWide })}>
              {children}
            </div>
          </ScrollArea>
        </SheetContent>
      </Sheet>
    )
  }
)

ComposedSheet.displayName = 'ComposedSheet'
